/*
 * @Author: Chao Yang
 * @Date: 2019-10-09 06:18:14
 * @LastEditor: Chao Yang
 * @LastEditTime : 2020-01-08 10:32:33
 */
import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[adTemplate]'
})
export class AlterDomusTemplateDirective {
  @Input('adTemplate')
  name: string;
  @Input()
  type: string;

  constructor(public template: TemplateRef<any>) {}

  getType(): string {
    return this.name;
  }
}
